import axios from "axios";
import axiosInstance from "../../../../Utils/axios";
import { paginationQueryParams } from "../../../../Utils/paginationParam";
let cancelToken;

const freightURL = `api/v1/core-app/freight`;
//obtaining the paginated data
export const getFreight = ({ rowsPerPage, search, sortOrder, pageNo }) => {
  if (cancelToken) {
    cancelToken.cancel("Operation canceled due to new request.");
  }
  cancelToken = axios.CancelToken.source();

  return axiosInstance.get(`${freightURL}/list?${paginationQueryParams(rowsPerPage, search, sortOrder, pageNo)}`, {
    cancelToken: cancelToken.token,
  });
};

//obtaining all fiscal sessions
export const getAllFreight = () => axiosInstance.get(`${freightURL}/list?ordering=-id`);

//obtaining the previous page data from paginated data
export const getPrevious = (previous) => axiosInstance.get(previous);

//obtaining the next page data from paginated data
export const getNext = (next) => axiosInstance.get(next);

//obtaining the particular page data from paginated data
export const getPageFreight = ({ number, rowsPerPage, search }) =>
  axiosInstance.get(`${freightURL}/list?${paginationQueryParams(rowsPerPage, search, "", number)}`);

export const getFreightById = (id) => axiosInstance.get(`${freightURL}/retrieve/${id}`);

//creating function
export const createFreight = (body) => axiosInstance.post(`${freightURL}/create`, body);
//updating function
export const updateFreight = (id, body) => axiosInstance.patch(`${freightURL}/update/${id}`, body);

//searching function
export const handleSearch = (search, rowsPerPage) =>
  axiosInstance.get(`${freightURL}/list?offset=0&limit=${rowsPerPage}&search=${search}`);

// checking the redundant data
export const checkRedundantDataFreightName = (e, cancelToken) =>
  axiosInstance.get(`${freightURL}/list?name=${e.target.value.trim()}`, {
    cancelToken: cancelToken.token,
  });
